import { css } from 'styled-components';
import { baseColor, mobile, primaryColor, smallDesktop } from '../../../styles/general/theme';
import { DsPrimaryButtonStyle, DsSecondaryButtonStyle } from '../../button/ds/ds-button';

export const DsRichTextStyle = css<{
  standardPro?: boolean;
  disableOverflow?: boolean;
  overFlowWrap?: string;
  removeTopMargin?: boolean;
}>`
  @media (max-width: ${smallDesktop}px) {
    width: 100%;
  }

  img {
    max-width: 100%;
  }

  @media (max-width: ${mobile}px) {
    p {
      img {
        margin: 20px 0 !important;
        object-fit: cover;
        max-width: 100%;
      }
    }
  }

  em {
    font-style: italic;

    strong {
      font-style: italic;
    }
  }

  h2 span {
    font-weight: bold;
  }

  ${(p) =>
    p.removeTopMargin &&
    css`
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        margin-top: 0 !important;
      }
    `};

  ${(p) =>
    p.disableOverflow &&
    css`
      overflow: hidden;
    `};

  ${(p) =>
    p.standardPro &&
    css`
      td {
        padding: 10px;
      }

      tbody {
        & tr {
          border-bottom: 2px solid #a5978f;
          color: ${baseColor(150)};
          font-weight: 400;

          &:first-child {
            font-weight: 700;
            font-size: 16px;
          }
        }
      }

      .custom-separator {
        border-bottom: 1px solid #1a1b1b;
        height: 1px;
        width: 150px;
        margin: 0 auto;
      }
    `};

  .richtext-tooltip {
    & svg {
      circle {
        stroke-width: 0.7;
        stroke: ${primaryColor(350)};
      }

      path {
        fill: ${primaryColor(350)};
        stroke-width: 0.5;
        stroke: ${primaryColor(350)};
      }
    }
  }

  .primary-button {
    ${DsPrimaryButtonStyle};
    display: inline-flex;
    color: ${baseColor(900)} !important;
    background-color: ${baseColor(200)};

    :hover {
      background-color: ${primaryColor(500)};
      border: none;
    }
  }

  .secondary-button {
    ${DsSecondaryButtonStyle};
    display: inline-flex;
  }

  .primary-link {
    color: ${baseColor(200)} !important;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;

    &:after {
      content: ' ';
      border-bottom: 2px solid ${baseColor(200)};
      display: inline-block;
      border-right: 2px solid ${baseColor(200)};
      transform: rotate(315deg);
      width: 5px;
      height: 5px;
      margin-bottom: 2px;
      margin-left: 10px;
    }

    &:hover {
      color: ${primaryColor(500)} !important;
      cursor: pointer;

      &:after {
        border-color: ${primaryColor(500)} !important;
      }
    }
  }

  .primary-link-left:before {
    content: ' ';
    width: 89px;
    border-bottom: 2px solid ${primaryColor(500)};
    display: block;
    margin-bottom: 12px;
    margin-top: 18px;
  }
`;
